import { PLAN_IDS } from "../../constants/plans";

export const LANDING_PLAN_CATALOG = [
    {
        code: "trial",
        title: "Teste Grátis",
        headline: "14 dias para validar toda a operação",
        description: "Ideal para conhecer o NeoApp completo antes de contratar.",
        price: 0,
        periodLabel: "/14 dias",
        amount: 0,
        planId: PLAN_IDS.NEO,
        highlighted: false,
        badge: "14 dias sem custo",
        ctaLabel: "Começar Agora",
        isTrial: true,
        installments: 1,
        features: [
            { text: "Acesso total a todas as funcionalidades", active: true },
            { text: "Gestão comercial e financeira", active: true },
            { text: "Automações e evolução de alunos", active: true },
            { text: "Suporte prioritário na implantação", active: true }
        ],
    },
    {
        code: "personal",
        title: "Personal",
        headline: "Perfeito para profissionais autônomos",
        description: "Faça a gestão da sua agenda e turmas com o custo-benefício que você precisa. Limite de 25 alunos.",
        price: 99,
        periodLabel: "/mês",
        amount: 99,
        planId: PLAN_IDS.PERSONAL,
        highlighted: false,
        badge: null,
        ctaLabel: "Assinar",
        isTrial: false,
        installments: 1,
        features: [
            { text: "Até 25 alunos ativos", active: true },
            { text: "Acesso Individual (1 Professor)", active: true },
            { text: "Grade de horários e presenças", active: true },
            { text: "Avaliações e planejamento", active: true },
            { text: "Dashboards Financeiro e Gerencial", active: false },
            { text: "CRM, Caixa e Automações", active: false },
        ],
    },
    {
        code: "basic",
        title: "Básico",
        headline: "Estrutura essencial para começar com consistência",
        description: "Para operações enxutas que precisam organizar equipe e métricas. Até 120 alunos.",
        price: 199,
        periodLabel: "/mês",
        amount: 199,
        planId: PLAN_IDS.BASIC,
        highlighted: false,
        badge: null,
        ctaLabel: "Assinar",
        isTrial: false,
        installments: 1,
        features: [
            { text: "Até 120 alunos ativos", active: true },
            { text: "Múltiplos Colaboradores/Equipe", active: true },
            { text: "Dashboard Gerencial (Métricas)", active: true },
            { text: "Módulo avançado de avaliações", active: true },
            { text: "Financeiro Completo e Vendas", active: false },
            { text: "CRM e Inteligência Artificial", active: false },
        ],
    },
    {
        code: "master",
        title: "Master",
        headline: "Operação financeira completa para crescimento",
        description: "Retenção, gestão de vendas e controle financeiro total. Sem limite de alunos.",
        price: 299,
        periodLabel: "/mês",
        amount: 299,
        planId: PLAN_IDS.MASTER,
        highlighted: true,
        badge: "Mais vendido",
        ctaLabel: "Assinar",
        isTrial: false,
        installments: 6,
        features: [
            { text: "Alunos ilimitados", active: true },
            { text: "Dashboard Financeiro Diário", active: true },
            { text: "CRM (Gestão de leads e clientes)", active: true },
            { text: "Módulo Financeiro (DRE, Caixa)", active: true },
            { text: "Vendas e Cadastro de Planos", active: true },
            { text: "Inteligência Artificial e Quiosque", active: false },
        ],
    },
    {
        code: "neo",
        title: "Plano Neo",
        headline: "Camada premium com automação, IA e expansão",
        description: "A solução definitiva pensada para redes e alta performance técnica.",
        price: 490,
        periodLabel: "/mês",
        amount: 490,
        planId: PLAN_IDS.NEO,
        highlighted: false,
        badge: "Acesso Completo",
        ctaLabel: "Assinar",
        isTrial: false,
        installments: 12,
        features: [
            { text: "Tudo do Plano Master", active: true },
            { text: "Geração de Treinos com Inteligência Artificial", active: true },
            { text: "Módulo Quiosque (Painel TV na Piscina)", active: true },
            { text: "Automações Cloud (Evolution API/Zap)", active: true },
            { text: "Gamificação (Rankings e Conquistas)", active: true },
            { text: "Performance de Equipe e Metas", active: true },
        ],
    },
];

export const getLandingPlanByCode = (code) => (
    LANDING_PLAN_CATALOG.find((plan) => plan.code === code) || null
);

export const getLandingPlanByTitle = (title) => (
    LANDING_PLAN_CATALOG.find((plan) => plan.title.toLowerCase() === String(title || "").toLowerCase()) || null
);
